import React from 'react';
import './Notifications.css'
import NavDock from '../Components/Layout/NavDock';

import Curve from '../Assets/Icons/Curve.svg'

const Notifications = () => {
    return ( 
        <main className='Notifications'>
            <div className='TopBar'></div>
            <div className='NotifMain'>

            </div>
            <NavDock Curve={Curve} NotchClass='NotchCurve'/>
        </main>
     );
}
 
export default Notifications;